import React from 'react';
import AiPresenceOrb from './AiPresenceOrb';
import FitBox from './FitBox';

/**
 * The call "stage" — the central focus of the video-conference shell.
 *
 * Phase 1 (now): the AI presence avatar + live equalizer over an ambient, state-tinted backdrop.
 * Phase 2 (avatar): drop a <AvatarVideo /> bound to the WebRTC track into this same slot;
 * the captions and controls around it do not change.
 */
const GLOW = {
  // brand palette: primary #3B5BDB · secondary #20C997 · accent #845EF7
  speaking: 'rgba(132,94,247,0.20)',   // accent purple
  listening: 'rgba(59,91,219,0.22)',   // primary blue
  thinking: 'rgba(32,201,151,0.18)',   // secondary teal
  idle: 'rgba(148,163,184,0.10)',
};

const StageAvatar = ({ aiState = 'idle', level = 0, compact = false, stateLabel }) => (
  <div
    className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl
      border border-slate-200 bg-gradient-to-b from-slate-50 to-slate-200
      dark:border-white/5 dark:from-slate-900 dark:to-slate-950"
  >
    {/* ambient state glow */}
    <div
      className="pointer-events-none absolute inset-0 transition-[background] duration-500"
      style={{ background: `radial-gradient(60% 55% at 50% 42%, ${GLOW[aiState] || GLOW.idle}, transparent 70%)` }}
    />
    {/* faint grid texture (slate lines read on both light and dark) — skip in tiny PiPs */}
    {!compact && (
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.12] dark:opacity-[0.06]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(100,116,139,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(100,116,139,0.7) 1px, transparent 1px)',
          backgroundSize: '34px 34px',
          maskImage: 'radial-gradient(70% 70% at 50% 50%, #000, transparent)',
          WebkitMaskImage: 'radial-gradient(70% 70% at 50% 50%, #000, transparent)',
        }}
      />
    )}
    {/* Orb scaled to fit ANY size (stage / half-tile / PiP) so it's never cut off. */}
    {/* Phase 2: drop <AvatarVideo /> into this same slot. */}
    <FitBox width={300} height={compact ? 288 : 408} className="h-full w-full">
      <AiPresenceOrb state={aiState} level={level} compact={compact} stateLabel={stateLabel} />
    </FitBox>
  </div>
);

export default StageAvatar;
